<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <div class="brand-section">
        <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
        <h2 class="brand-title">VAT E-Service</h2>
      </div>
      <h1 class="login-title">เข้าสู่ระบบ</h1>
      <p class="login-subtitle">กรุณาเข้าสู่ระบบเพื่อเข้าใช้งาน</p>
    </div>

    <!-- Login Type Toggle -->
    <div class="login-type-toggle">
      <button 
        type="button" 
        class="toggle-btn" 
        [class.active]="isCidLogin"
        (click)="switchLoginType('cid')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        ผู้ใช้งาน (รหัสบัตรประชาชน)
      </button>
      <button 
        type="button" 
        class="toggle-btn" 
        [class.active]="isEmailLogin"
        (click)="switchLoginType('email')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        เจ้าหน้าที่ (Email)
      </button>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage" role="alert" aria-live="polite">
      <div class="error-content">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        <span>{{ errorMessage }}</span>
      </div>
      <div class="error-actions">
        <button 
          type="button" 
          class="retry-btn"
          *ngIf="isRetryableError"
          (click)="retryLogin()"
          [disabled]="isLoading"
          aria-label="ลองเข้าสู่ระบบใหม่">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="23 4 23 10 17 10"></polyline>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
          </svg>
          ลองใหม่
        </button>
        <button 
          type="button" 
          class="clear-error-btn"
          (click)="clearErrorMessage()"
          aria-label="ปิดข้อความแจ้งเตือน">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>



    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <!-- Identifier Input -->
      <div class="input-group">
        <div class="input-wrapper">
          <input
            id="identifier"
            type="text"
            formControlName="identifier"
            class="form-input"
            [class.error]="identifier?.invalid && identifier?.touched"
            [placeholder]="isEmailLogin ? 'กรุณากรอกอีเมล' : 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก'"
            [maxlength]="isEmailLogin ? 255 : 13"
            autocomplete="username">
          <div class="input-icon">
            <svg *ngIf="isEmailLogin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <svg *ngIf="isCidLogin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
        </div>
        <div class="field-error" *ngIf="identifier?.invalid && identifier?.touched">
          <div class="error-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
          <div class="error-message-text">
            <div *ngIf="identifier?.errors?.['required']">
              {{ isEmailLogin ? 'กรุณากรอกอีเมล' : 'กรุณากรอกรหัสบัตรประชาชน' }}
            </div>
            <div *ngIf="identifier?.errors?.['email']">
              รูปแบบอีเมลไม่ถูกต้อง
            </div>
            <div *ngIf="identifier?.errors?.['pattern'] || identifier?.errors?.['minlength'] || identifier?.errors?.['maxlength']">
              รหัสบัตรประชาชนต้องเป็นตัวเลข 13 หลัก
            </div>
          </div>
        </div>
      </div>

      <!-- Password Input -->
      <div class="input-group">
        <div class="input-wrapper">
          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            class="form-input"
            [class.error]="password?.invalid && password?.touched"
            placeholder="กรุณากรอกรหัสผ่าน"
            autocomplete="current-password">
          <div class="input-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <circle cx="12" cy="16" r="1"></circle>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <button 
            type="button" 
            class="password-toggle-btn"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
            tabindex="-1">
            <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
          </button>
        </div>
        <div class="field-error" *ngIf="password?.invalid && password?.touched">
          <div class="error-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
          <div class="error-message-text">
            <div *ngIf="password?.errors?.['required']">
              กรุณากรอกรหัสผ่าน
            </div>
            <div *ngIf="password?.errors?.['minlength']">
              รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <button 
        type="submit" 
        class="submit-btn"
        [disabled]="isLoading"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">เข้าสู่ระบบ</span>
        <span *ngIf="isLoading" class="loading-spinner">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 12a9 9 0 11-6.219-8.56"/>
          </svg>
          กำลังเข้าสู่ระบบ...
        </span>
      </button>

      <!-- Forget Password Button -->
      <button 
        type="button" 
        class="forget-password-btn"
        routerLink="/forget-password">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2a10 10 0 0 0-9.95 9h11.64L9.74 7.05a1 1 0 0 1 1.41-1.41l5.66 5.65a1 1 0 0 1 0 1.42l-5.66 5.65a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41L13.69 13H2.05A10 10 0 1 0 12 2z"></path>
        </svg>
        ลืมพาสเวิร์ด
      </button>

      <!-- Registration Button -->
      <button 
        type="button" 
        class="register-btn"
        routerLink="/pre-register">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="8.5" cy="7" r="4"></circle>
          <line x1="20" y1="8" x2="20" y2="14"></line>
          <line x1="23" y1="11" x2="17" y2="11"></line>
        </svg>
        ลงทะเบียน
      </button>
    </form>

    <!-- Test Button for debugging -->
    <!-- <div style="margin: 10px 32px;">
      <button 
        type="button" 
        (click)="testError()"
        style="padding: 8px 16px; background: #ff6b6b; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
        ทดสอบข้อความแจ้งเตือน
      </button>
    </div> -->

    <!-- Debug Info -->
    <!-- <div style="margin: 10px 32px; padding: 10px; background: #f0f0f0; border-radius: 4px; font-size: 12px; color: #666;">
      <strong>Debug Info:</strong><br>
      errorMessage: "{{ errorMessage }}"<br>
      errorType: "{{ errorType }}"<br>
      isLoading: {{ isLoading }}<br>
      Has errorMessage: {{ !!errorMessage }}<br>
      errorMessage Length: {{ errorMessage?.length || 0 }}
    </div> -->

    <!-- Footer -->
    <div class="login-footer">
      <p>&copy; 2026 VAT Management System. All rights reserved.</p>
    </div>
  </div>
</div> 